const allDay = "allDay"
const firstHalf = "firstHalf"
const secondHalf = "secondHalf"

export const BookingCalendarType = { allDay, firstHalf, secondHalf }
export default { allDay, firstHalf, secondHalf }
